import React, { HTMLAttributes } from 'react';

import styles from './styles.module.css';

export interface CardAppointmentProps extends HTMLAttributes<HTMLDivElement> {}

export const CardAppointment: React.FC<CardAppointmentProps> = ({
  children,
  ...props
}) => {
  return (
    <article className={styles.card} {...props}>
      {children}
    </article>
  );
};

export * from './CardAppointmentTrigger';
export * from './CardAppointmentTitle';
export * from './CardAppointmentBadge';
export * from './CardAppointmentContent';
